<template>
<div id="layouts_completar_pedimentos" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Armado Anexo 24" class="elevation-1 px-5 py-3" >
                    <br>
                    
                    <v-tabs grow style="margin-bottom: 30px;" >
                        <v-tabs-slider color="primary" ></v-tabs-slider>
                        <v-tab key="cargar_importaciones" @click="pestana_seleccionada='importacion'">Importaciones</v-tab>
                        <v-tab key="cargar_exportaciones" @click="pestana_seleccionada='exportacion'">Exportaciones</v-tab>
                        
                        <v-tab-item key="cargar_importaciones" >
                            <div class="contenedor-tab-reportes" >
                                <v-card-text>
                                <v-card-title>
                                    <span class="headline" ></span>
                                </v-card-title>
                                
                                </v-card-text>
                                
                                <v-card-text>
                                    <v-row>
                                        <v-col sm="5" md="5" lg="5" >
                                            1.- Descargar Layout Importaciones:
                                        </v-col>
                                        <v-col sm="1" md="1" lg="1" >
                                            <exportar-excel :data="camposLayoutImpo" :exportFields="encabezadoLayoutImpo" name="Layout_Importaciones.xlsx" >
                                            <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                                <v-icon dark>receipt</v-icon>
                                            </v-btn>
                                        </exportar-excel>
                                        </v-col>
                                        <v-col sm="5" md="5" lg="5" v-if="puede_generar_layout()">
                                            Descargar Layout de Importaciones pre-llenado:
                                        </v-col>
                                        <v-col sm="1" md="1" lg="1" v-if="puede_generar_layout()">
                                            <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy @click="descargar_prellenado(1)">
                                                <v-icon dark>receipt</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col sm="5" md="5" lg="5" >
                                            2.- Carga de Layout de Importaciones:
                                            <br>Seleccione periodo del layout:
                                            <v-form ref="form_dates" lazy-validation>
                                            <v-row>                                                
                                                <v-col sm="6" md="6" lg="6" >
                                                    <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" >
                                                        <template v-slot:activator="{ on }" >
                                                            <v-text-field v-on="on" v-model="fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="fecha_de = parseDate(fecha_de)" v-mask="'####-##-##'" :rules="[rules.required, validaDias, validaFecha]" >
                                                            </v-text-field>
                                                        </template>

                                                        <v-date-picker v-model="fecha_de" color="secondary"  scrollable locale="es-mx" @input="menu1 = false" >
                                                            <v-spacer />

                                                            <v-btn color="secondary" x-small @click="menu1 = false" >
                                                            Cancelar
                                                            </v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-col>
                                                <v-col sm="6" md="6" lg="6" >
                                                    <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" >
                                                        <template v-slot:activator="{ on }" >
                                                            <v-text-field v-on="on" v-model="fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="fecha_a = parseDate(fecha_a)" v-mask="'####-##-##'" :rules="[rules.required, validaDias, validaFecha]" >
                                                            </v-text-field>
                                                        </template>

                                                        <v-date-picker v-model="fecha_a" color="secondary"  scrollable locale="es-mx" @input="menu2 = false" >
                                                            <v-spacer />

                                                            <v-btn color="secondary" x-small @click="menu2 = false" >
                                                            Cancelar
                                                            </v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-col>
                                            </v-row>
                                            <v-row style="margin-top: -30px !important;">                                                
                                                <v-col>
                                                    <v-checkbox v-model="valida_pedimentos_layout" label="Buscar y validar únicamente pedimentos en el layout" :false-value="0" :true-value="1" ></v-checkbox>
                                                </v-col>                                                
                                            </v-row>
                                            </v-form>
                                        </v-col>
                                        <v-col sm="1" md="1" lg="1" >
                                            <upload-excel-component idInput="imposKey" :on-success="handleSuccessImpos" :before-upload="beforeUpload" />
                                        </v-col>
                                    </v-row>
                                    
                                </v-card-text>

                                <v-card-text>
                                    <v-card-actions>
                                        <v-refresh-button :funcion="cargar" />                                                                                
                                    </v-card-actions>

                                    <v-client-table ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                    </template>
                                    
                                    <template slot="estatus" slot-scope="props" >
                                        <span v-if="props.row.estatus=='En Proceso'">
                                            {{props.row.estatus+": "+props.row.faltantes+" registros pendientes"}}
                                        </span>
                                        <span v-else>
                                            {{props.row.estatus}}
                                        </span>                                        
                                    </template>

                                    <template slot="errores" slot-scope="props" >
                                        <span v-if="(props.row.errores && props.row.errores.length>0)"><v-btn x-small outlined color="blue" @click="verErrores(props.row)">Ver Errores</v-btn></span>
                                        <span v-else>&nbsp;</span>                                        
                                    </template>

                                    <template slot="layout_cargado" slot-scope="props" >
                                        <v-btn text icon color="secondary" title="Layout Cargado" @click="getTablaPedimentos(props.row.id, props.row.archivo, props.row.periodo, 1,'layout')" >
                                            <v-icon dark>mdi-file</v-icon>
                                        </v-btn>
                                    </template>
                                    <template slot="layout_generado" slot-scope="props" >
                                        <v-btn v-if="!['Pendiente','En Proceso'].includes(props.row.estatus)" text icon color="success" title="Layout Generado" @click="getTablaPedimentos(props.row.id, props.row.archivo, props.row.periodo, 1,'completo')" >
                                            <v-icon dark>mdi-file-export</v-icon>
                                        </v-btn>
                                    </template>
                                    <template slot="layout_validacion" slot-scope="props" >
                                        <v-btn v-if="!['Pendiente','En Proceso'].includes(props.row.estatus)" text icon color="purple" title="Validacion" @click="getValidacion(props.row.id, props.row.archivo, props.row.periodo)" >
                                            <v-icon dark>mdi-file-check</v-icon>
                                        </v-btn>
                                    </template>

                                    <template slot="actions" slot-scope="props" >                                        
                                        <v-btn text icon color="red" title="Eliminar Registro" @click="eliminarReporte(props.row.id)" >
                                            <v-icon dark>delete</v-icon>
                                        </v-btn>
                                        <v-btn v-if="(props.row.estatus=='En Proceso' && superUsuario)" text icon color="blue" title="Continuar Proceso"                                         
                                            @click="continuar_completar(props.row.id, props.row.rfc)" >
                                            <v-icon dark>send</v-icon>
                                        </v-btn>
                                    </template>
                                    </v-client-table>
                                    
                                </v-card-text>

                            </div>     
                        </v-tab-item>
                        <v-tab-item key="cargar_exportaciones" >
                            <div class="contenedor-tab-reportes" >
                                <v-card-text>
                                <v-card-title>
                                    <span class="headline" ></span>
                                </v-card-title>
                                
                                </v-card-text>
                                
                                <v-card-text>
                                  <v-row>
                                        <v-col sm="5" md="5" lg="5" >
                                            1.- Descargar Layout Exportaciones:
                                        </v-col>
                                        <v-col sm="1" md="1" lg="1" >
                                            <exportar-excel :data="camposLayoutExpo" :exportFields="encabezadoLayoutExpo" name="Layout_Exportaciones.xlsx" >
                                            <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                                <v-icon dark>receipt</v-icon>
                                            </v-btn>
                                        </exportar-excel>
                                        </v-col>
                                        <v-col sm="5" md="5" lg="5" v-if="puede_generar_layout()">
                                            Descargar Layout de Importaciones pre-llenado:
                                        </v-col>
                                        <v-col sm="1" md="1" lg="1" v-if="puede_generar_layout()">
                                            <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy @click="descargar_prellenado(2)">
                                                <v-icon dark>receipt</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col sm="5" md="5" lg="5" >
                                            2.- Carga de Layout de Exportaciones:
                                            <br>Seleccione periodo del layout:
                                            <v-form ref="form_dates" lazy-validation>
                                            <v-row>                                                
                                                <v-col sm="6" md="6" lg="6" >
                                                    <v-menu offset-x ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" >
                                                        <template v-slot:activator="{ on }" >
                                                            <v-text-field v-on="on" v-model="fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="fecha_de = parseDate(fecha_de)" v-mask="'####-##-##'" :rules="[rules.required, validaDias, validaFecha]" >
                                                            </v-text-field>
                                                        </template>

                                                        <v-date-picker v-model="fecha_de" color="secondary"  scrollable locale="es-mx" @input="menu3 = false" >
                                                            <v-spacer />

                                                            <v-btn color="secondary" x-small @click="menu3 = false" >
                                                            Cancelar
                                                            </v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-col>
                                                <v-col sm="6" md="6" lg="6" >
                                                    <v-menu offset-x ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" >
                                                        <template v-slot:activator="{ on }" >
                                                            <v-text-field v-on="on" v-model="fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="fecha_a = parseDate(fecha_a)" v-mask="'####-##-##'" :rules="[rules.required, validaDias, validaFecha]" >
                                                            </v-text-field>
                                                        </template>

                                                        <v-date-picker v-model="fecha_a" color="secondary"  scrollable locale="es-mx" @input="menu4 = false" >
                                                            <v-spacer />

                                                            <v-btn color="secondary" x-small @click="menu4 = false" >
                                                            Cancelar
                                                            </v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-col>
                                            </v-row>
                                            <v-row style="margin-top: -30px !important;">
                                                <v-col>
                                                    <v-checkbox v-model="valida_pedimentos_layout" label="Buscar y validar únicamente pedimentos en el layout" :false-value="0" :true-value="1" ></v-checkbox>
                                                </v-col>
                                            </v-row>
                                            </v-form>
                                        </v-col>
                                        <v-col sm="1" md="1" lg="1" >
                                            <upload-excel-component idInput="exposKey" :on-success="handleSuccessImpos" :before-upload="beforeUpload" />
                                        </v-col>
                                    </v-row>
                                </v-card-text>

                                <v-card-text>
                                    <v-card-actions>
                                        <v-refresh-button :funcion="cargar" />                                                                                
                                    </v-card-actions>

                                    <v-client-table ref="vuetable" :data="datos_expo" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                    </template>

                                    <template slot="estatus" slot-scope="props" >
                                        <span v-if="props.row.estatus=='En Proceso'">
                                            {{props.row.estatus+": "+props.row.faltantes+" registros pendientes"}}
                                        </span>
                                        <span v-else>
                                            {{props.row.estatus}}
                                        </span>                                        
                                    </template>

                                    <template slot="errores" slot-scope="props" >
                                        <span v-if="(props.row.errores && props.row.errores.length>0)"><v-btn x-small outlined color="blue" @click="verErrores(props.row)">Ver Errores</v-btn></span>
                                        <span v-else>&nbsp;</span>                                        
                                    </template>
                                    <template slot="layout_cargado" slot-scope="props" >
                                        <v-btn text icon color="secondary" title="Layout Cargado" @click="getTablaPedimentos(props.row.id, props.row.archivo, props.row.periodo, 2,'layout')" >
                                            <v-icon dark>mdi-file</v-icon>
                                        </v-btn>
                                    </template>
                                    <template slot="layout_generado" slot-scope="props" >
                                        <v-btn v-if="!['Pendiente','En Proceso'].includes(props.row.estatus)" text icon color="success" title="Layout Generado" @click="getTablaPedimentos(props.row.id, props.row.archivo, props.row.periodo, 2,'completo')" >
                                            <v-icon dark>mdi-file-export</v-icon>
                                        </v-btn>
                                    </template>
                                    <template slot="layout_validacion" slot-scope="props" >
                                        <v-btn v-if="!['Pendiente','En Proceso'].includes(props.row.estatus)" text icon color="purple" title="Validacion" @click="getValidacion(props.row.id, props.row.archivo, props.row.periodo)" >
                                            <v-icon dark>mdi-file-check</v-icon>
                                        </v-btn>
                                    </template>

                                    <template slot="actions" slot-scope="props" >
                                        <v-btn text icon color="red" title="Eliminar Registro" @click="eliminarReporte(props.row.id)" >
                                            <v-icon dark>delete</v-icon>
                                        </v-btn>
                                        <v-btn v-if="(props.row.estatus=='En Proceso' && superUsuario)" text icon color="blue" title="Continuar Proceso"                                        
                                            @click="continuar_completar(props.row.id, props.row.rfc)" >
                                            <v-icon dark>send</v-icon>
                                        </v-btn>
                                    </template>
                                    </v-client-table>
                                    
                                </v-card-text>

                            </div> 
                        </v-tab-item>
                    </v-tabs>                                                                   

                    <exportar-excel v-show="1==2" :data="data_completo" :exportFields="encabezadoCompleto" :name="nombre_archivo">
                        <v-btn id="botonExportarCompleto" fab dark x-small color="green" title="Exportar Completo" v-tippy>
                            <v-icon dark>mdi-table</v-icon>
                        </v-btn>
                    </exportar-excel>
                    <exportar-excel v-show="1==2" :data="data_completo" :exportFields="encabezadoCompletoExpo" :name="nombre_archivo">
                        <v-btn id="botonExportarCompletoExpo" fab dark x-small color="green" title="Exportar Completo" v-tippy>
                            <v-icon dark>mdi-table</v-icon>
                        </v-btn>
                    </exportar-excel>

                    <exportar-excel v-show="1==2" :data="data_completo" :exportFields="encabezadoLayoutOriginalImpo" :name="nombre_archivo">
                        <v-btn id="botonExportarLayout" fab dark x-small color="green" title="Exportar Layout" v-tippy>
                            <v-icon dark>mdi-table</v-icon>
                        </v-btn>
                    </exportar-excel>             
                    <exportar-excel v-show="1==2" :data="data_completo" :exportFields="encabezadoLayoutOriginalExpo" :name="nombre_archivo">
                        <v-btn id="botonExportarLayoutExpo" fab dark x-small color="green" title="Exportar Layout" v-tippy>
                            <v-icon dark>mdi-table</v-icon>
                        </v-btn>
                    </exportar-excel>
                    <exportar-excel v-show="1==2" :data="validacion" :exportFields="encabezadoValidacion" :name="nombre_archivo">
                        <v-btn id="botonExportarValidacion" fab dark x-small color="green" title="Exportar Layout" v-tippy>
                            <v-icon dark>mdi-table</v-icon>
                        </v-btn>
                    </exportar-excel>
                    
                </base-material-card>
                
            </v-flex>
        </v-layout>
    </v-container>

    <v-dialog v-model="modal_pedimentos" max-width="80%" style=" z-index: 400 !important;" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon class="white--text" @click.native="modal_pedimentos = false">
                        cancel</v-icon>&nbsp;
                    <span class="subheading" >
                        <strong>Pedimentos</strong>
                    </span>
                </v-card>
                <v-spacer></v-spacer>                
            </v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <exportar-excel :data="data_resumen" :exportFields="data_resumen_excel" name="Etiquetas_pedimentos.xlsx" >
                    <v-btn dark small color="success" title="Exportar Detalle" v-tippy>
                        <v-icon dark>get_app</v-icon> Exportar Detalle
                    </v-btn>
                </exportar-excel>   
                
            </v-card-actions>
            <v-card-text>       
                <v-client-table ref="vuetabledetalle" :data="data_resumen" :columns="columns_resumen" :options="options_resumen" class="elevation-2 pa-2" >
                    <template slot="noResults" >
                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                    </template>
                    <template slot="URL" slot-scope="props">
                        <a :href="props.row.URL" target="_blank">{{props.row.URL}}</a>
                    </template>
                    
                </v-client-table>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modal_pedimentos = false" >
                    <v-icon>cancel</v-icon>Cerrar
                </v-btn>                                
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="modal_errores" max-width="60%" style=" z-index: 400 !important;" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon class="white--text" @click.native="modal_errores = false">
                        cancel</v-icon>&nbsp;
                    <span class="subheading" >
                        <strong>Errores</strong>
                    </span>
                </v-card>
                <v-spacer></v-spacer>                
            </v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <exportar-excel :data="data_errores" :exportFields="data_errores_excel" name="Errores_encontrados.xlsx" >
                    <v-btn dark small color="success" title="Exportar Detalle" v-tippy>
                        <v-icon dark>get_app</v-icon> Exportar Detalle
                    </v-btn>
                </exportar-excel> &nbsp;

                <span v-if="['SME1302011P5','SAK960514KC5','LAE141126MI4','SIM900831LS2'].includes(rfc_layout)"> <!-- Lo solicitaron solo para este RFC:SME1302011P5, SAK960514KC5, LAE141126MI4, SIM900831LS2 -->
                    <v-btn v-if="estatus_layout=='Con Errores'" small color="red" title="Enviar a Recuperación" 
                        @click="enviar_recuperar(id_layout, rfc_layout)" >
                        <v-icon dark>done</v-icon> Enviar a Recuperación
                    </v-btn> &nbsp;

                    <v-btn v-if="estatus_layout=='Enviados a Recuperación'" small color="gray" title="Revalidar Layout" 
                        @click="continuar_completar(id_layout, rfc_layout, 1)" >
                        <v-icon dark>refresh</v-icon> Revalidar Layout
                    </v-btn>
                </span>
                
            </v-card-actions>
            <v-card-text>       
                <v-client-table ref="vuetabledetalleerrores" :data="data_errores" :columns="columns_errores" :options="options_errores" class="elevation-2 pa-2" >
                    <template slot="noResults" >
                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                    </template>                    
                </v-client-table>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modal_errores = false" >
                    <v-icon>cancel</v-icon>Cerrar
                </v-btn>                                
            </v-card-actions>
        </v-card>
    </v-dialog>

    
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";
import XLSX from 'xlsx';

export default {
    components: {
        "v-refresh-button": RefreshButton,
    },

data: () => ({
        nombre_archivo:"",
        id_layout:"",
        rfc_layout:"",
        estatus_layout:"",
        superUsuario:false,
        validacion: [],
        modal_fechas:false,
        menu1:false,
        menu2:false,
        menu3: false,
        menu4: false,
        fecha_de:"",
        fecha_a:"",
        valida_pedimentos_layout:0,
        pestana_seleccionada:"importacion",
        completo_visible:false,
        layout_visible:false,
        data_completo:[],
        encabezadoCompleto: {
            "Pedimento": "pedimento_separado",
            "Fecha pago":"fecha_pago_real",
            "Fecha entrada":"fecha_entrada",
            "Tipo cambio":"tipo_cambio",
            "Regimen":	"regimen",
            "Clave":	"clave_pedimento",
            "Patente":	"patente",
            "Aduana":	"aduana",
            "Seccion":	"seccion",
            "Val. Seguros":	"val_seguros",
            "Seguros":	"seguros",
            "Fletes":	"fletes",
            "Embalajes": "embalajes",
            "Otros incrementables":"otros_incrementables",	
            "PRV":	"prv",
            "IVA PRV":	"iva_prv",
            "CNT":	"cnt",
            "DTA":	"dta",
            "Adicional 1":"",	
            "Adicional 2":"",	
            "Adicional 3":"",
            "Descripcion":"no_pedimento",	
            "Factura":"factura",	
            "Fecha":"fecha_factura",	
            "Tipo cambio ":"tipo_cambio",	
            "Clave proveedor":"proveedor",
            "Incoterm":"",	
            "Moneda Fact.":"moneda",	
            "Factor Mon. Fact.":"factor_moneda",	
            "Descripcion Vehiculo":"",	
            "Patente ":"",	
            "Descripcion ":"",	
            "Observaciones":"",	
            "Adicional 1 ":"",
            "Adicional 2 ":"",
            "Adicional 3 ":"",
            "EDocument":"cove",	
            "Material":"material",	
            "Cantidad UM Adicional":"",
            "UM Adicional":"",
            "Cantidad UM Base":"cantidad",
            "UM Base":"unidad_medida",
            "Valor Mon. Fact.":"valor_mercancia",
            "Valor USD":"valor_usd",	
            "Categoria":"categoria",	
            "Fraccion":"fraccion",	
            "Pais origen":"pais_origen",
            "TLC":"tlc",	
            "Prosec":"prosec",	
            "Clave Permiso":"clave_permiso",	
            "% Advalorem":"tasa_igi",
            "Regla 2da":"",	
            "Forma pago":"fp_igi",
            "Metodo valoracion":"metodo_valoracion",	
            "% IVA":"tasa_iva",	
            "Forma de pago IVA":"fp_iva",	
            "Forma de pago IEPS":"",	
            "Almacen":"",	
            "Serie":"",	
            "Referencia Contable":"",	
            "Empaque":"",	
            "Cant. Empaque":"",	
            "Peso Gross":"",	
            "Peso Neto":"",	
            "Descripcion Ped":"descripcion_pedimento",	
            "Orden Compra":"",	
            "Serie":"comentarios",
            "Exp. Temporal":"",	
            "Adicional 1  ":"",
            "Adicional 2  ":"cantidad",	
            "Adicional 3  ":"unidad_medida",
            "Adicional 4  ":"kilos",
            "Adicional 5  ":"adicional5",
            "Relacion Descargo":"",
            "Archivo":"origen",	
            "Secuencia":"secuencia",	
            "Ensamblado":"",	
            "No. Identificacion":"",	
            "Automatico":"",
        },
        encabezadoCompletoExpo: {
            "Pedimento": "pedimento_separado",
            "Fecha pago":"fecha_pago_real",
            "Fecha presentacion":"fecha_entrada",
            "Tipo cambio":"tipo_cambio",
            "Regimen":	"regimen",
            "Clave":	"clave_pedimento",
            "Patente":	"patente",
            "Aduana":	"aduana",
            "Seccion":	"seccion",
            "Prev":	"prv",
            "IVA PRV":	"iva_prv",
            "CNT":	"cnt",
            "DTA":	"dta",
            "Adicional 1":"",	
            "Adicional 2":"",	
            "Adicional 3":"",
            "Descripcion":"no_pedimento",	
            "Factura":"factura",	
            "Fecha":"fecha_factura",	
            "Tipo cambio ":"tipo_cambio",	
            "Clave Cliente":"proveedor",
            "Destinatario":"",
            "Incoterm":"",	
            "Moneda Fact.":"moneda",	
            "Factor Mon. Fact.":"factor_moneda",	
            "Descripcion Vehiculo":"",	
            "Patente ":"",	
            "Adicional 1 ":"",
            "Adicional 2 ":"",
            "Adicional 3 ":"",
            "EDocument":"cove",	
            "Material":"material",	
            "Cantidad UM Adicional":"",
            "UM Adicional":"",
            "Cantidad UM Base":"cantidad",
            "UM Base":"unidad_medida",
            "Valor Mon. Fact.":"valor_mercancia",
            "Valor USD":"valor_usd",	
            "Fraccion":"fraccion",	
            "Pais dest.":"pais_origen",
            "Empaque":"",	
            "Cant. Empaque":"",	
            "Peso Gross":"",	
            "Peso Neto":"",	
            "Descripcion Ped":"descripcion_pedimento",	
            "Orden Venta":"",	
            "Serie":"comentarios",
            "Almacen":"",
            "Adicional 1  ":"",
            "Adicional 2  ":"cantidad",	
            "Adicional 3  ":"unidad_medida",
            "Adicional 4  ":"kilos",
            "Adicional 5  ":"adicional5",
            "Relacion Descargo":"",
            "Archivo":"origen",	
            "Secuencia":"secuencia",	
            "Automatico":"",
        },
         encabezadoLayoutOriginalImpo: {
            "Pedimento": "pedimento",
            "Fecha Pago":"fecha_pago_real",     
            "Factura":"factura",
            "COVE":"cove",
            "Fecha Factura":"fecha_factura",
            "Proveedor":"proveedor",
            "Material (# de Parte)":"material",
            "Cantidad":"cantidad",
            "Unidad de medida":"unidad_medida",
            "Kilos":"kilos",
            "Valor $":"valor_mercancia",
            "Moneda":"moneda",
            "Secuencia":"secuencia",
            "Comentarios":"comentarios"
        },
        encabezadoLayoutOriginalExpo: {
            "Pedimento": "pedimento",
            "Fecha Pago":"fecha_pago_real",     
            "Factura":"factura",
            "COVE":"cove",
            "Fecha Factura":"fecha_factura",
            "Cliente":"proveedor",
            "Material (# de Parte)":"material",
            "Cantidad":"cantidad",
            "Unidad de medida":"unidad_medida",
            "Kilos":"kilos",
            "Valor $":"valor_mercancia",
            "Moneda":"moneda",
            "Secuencia":"secuencia",
            "Comentarios":"comentarios"
        },
        encabezadoValidacion: {
            "Etiquetas de fila": "key",
            "Pedimento": "pedimento",
            "Secuencia": "secuencia",
            "Fecha Pago": "fecha",
            "Clave Pedimento":"clave",
            "Suma de Valor Dólares DS/WS":"ds_dolares",     
            "Suma Valor Dólares Layout":"layout_dolares",
            "Diferencia Valor":"diferencia",
            "Suma Cantidad DS/WS":"ds_cantidad",
            "Suma Cantidad Layout": "layout_cantidad",
            "Diferencia Cantidad":"diferencia_cantidad",
            "Comentarios":"comentario",
        },
        data_layout:[],
        file_adjunto: null,
        rules: {
            required: v => !!v || "Este campo es requerido"
        },
        URL:"",
        data_resumen:[],
        data_busqueda_excel: {
            "Solicitado":"solicitado",
            "Usuario":"usuario",
            "Tipo Operación":"tipo_operacion",
            "Patente":"patente",
            "Sección Aduanera":"seccion_aduanera",
            "Número Pedimento":"pedimento",
            "Fecha Pago Real":"fecha_pago_real",
            "Fecha Entrada":"fecha_entrada",
            "Año":"anio",
            "Clave Documento":"clave_documento",
            "Maquina No.":"no_maquina",
            "Línea":"linea",
            "Marca":"marca",
            "Modelo":"modelo",
            "Descripción":"descripcion",
            "Serie":"serie",
            "Observaciones":"observaciones",
            "Edificio":"edificio",
            "Estatus":"estatus",
            "Planta":"planta_referencia",
            "Error":"error",
            "URL":"URL"
        },
        data_errores_excel: {
            "Error":"error"
        },
        data_resumen_excel: {
            "Tipo Operación":"tipo_operacion",
            "Patente":"patente",
            "Sección Aduanera":"seccion_aduanera",
            "Número Pedimento":"pedimento",
            "Fecha Pago Real":"fecha_pago_real",
            "Fecha Entrada":"fecha_entrada",
            "Año":"anio",
            "Clave Documento":"clave_documento",
            "Maquina No.":"no_maquina",
            "Línea":"linea",
            "Marca":"marca",
            "Modelo":"modelo",
            "Descripción":"descripcion",
            "Serie":"serie",
            "Observaciones":"observaciones",
            "Edificio":"edificio",
            "Estatus":"estatus",
            "Planta":"planta_referencia",
            "Error":"error",
            "URL":"URL"
        },
        columns_errores:["error"],
        options_errores:{
            filterable:["error"],
            sortable:["error"],
             headings: {
                error:"Error",
             }
        },
        columns_resumen: ["tipo_operacion","patente","seccion_aduanera","pedimento","fecha_pago_real",
            "fecha_entrada","anio","clave_documento",
            "no_maquina","linea","marca","modelo","descripcion","serie","observaciones","edificio","estatus","planta_referencia"
            ,"error","URL"],
        options_resumen: {
            filterable: ["tipo_operacion","patente","seccion_aduanera","pedimento","fecha_pago_real",
            "fecha_entrada","anio","clave_documento","no_maquina","linea","marca","modelo","descripcion","serie","observaciones","edificio","estatus","planta_referencia"
            ,"error","URL"],
            sortable: ["tipo_operacion","patente","seccion_aduanera","pedimento","fecha_pago_real",
            "fecha_entrada","anio","clave_documento","no_maquina","linea","marca","modelo","descripcion","serie","observaciones","edificio","estatus","planta_referencia","error","URL"],
            headings: {
                tipo_operacion:"Tipo Operacion",
                patente:"patente",
                seccion_aduanera:"Sección Aduanera",
                numero_pedimento:"Número Pedimento",
                fecha_pago_real:"Fecha Pago Real",
                fecha_entrada:"Fecha Entrada",
                anio:"Año",
                clave_documento:"Clave Documento",
                "no_maquina":"Maquina No.",
                "planta_referencia":"Planta",
                marca:"Marca",
                modelo:"Modelo",
                serie:"Serie",
                informacion:"Información",
                error:"Error",
            }
        },
        modal_pedimentos:false,
        permisoEliminar: false,
        menu1: false,
        menu2: false,
        plantas_arr: [],
        edificios_arr: [],
        lineas_arr: [],
        codigo_qr:"",
        modal:false,
        modal_qr:false,
        model_editable:{
            pedimento: "",
            anio: "",
            no_maquina: "",
            linea: "",
            marca: "",
            modelo: "",
            descripcion: "",
            serie: "",
            observaciones: "",
            edificio: "",
            estatus: "",
            planta_referencia:""
        },
        model_busqueda:{
            fecha_de:"",
            fecha_a:"",
            planta:"",
            maquina:"",
            edificio:"",
            linea:"",
            pedimento:"",
        },
        name: "datagrid",
        importData: [],
        arrClaves:[],        
        URL: "",
        modal_errores:false,
        data_errores:[],

        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Reportes",
                disabled: true,
                to: ""
            },
            {
                text: "Armado Anexo 24",
                disabled: true,
                to: ""
            }
        ],
        loadingPlantas:false,
        loadingEdificios:false,
        loadingLineas:false,
        datos: [],
        datos_expo: [],
        datos_etiquetas:[],
        columns: ["id", "fecha", "archivo", "usuario", "estatus", "periodo", "errores", "layout_cargado","layout_generado","layout_validacion","actions"],
        options: {
            filterable: ["id", "fecha", "archivo", "usuario", "estatus", "periodo", "errores"],
            sortable: ["id", "fecha", "archivo", "usuario", "estatus", "periodo", "errores"],

            headings: {
                id: "No. Proceso",                
                fecha: "Fecha",
                archivo:"Nombre Archivo",
                usuario_email: "Usuario",
                estatus: "Estatus",
                errores: "Error",
                "layout_cargado":"Layout Cargado",
                "layout_generado":"Layout Generado",
                "layout_validacion":"Validación",
                actions: "Opciones"
            }
        },
        columnsEtiquetas: ["solicitado","usuario","planta_referencia", "no_maquina", "edificio", "linea", "fecha_pago_real", "pedimento","estatus","error", "actions"],
        optionsEtiquetas: {
            filterable: ["solicitado","usuario", "planta_referencia", "no_maquina", "edificio", "linea", "fecha_pago_real", "pedimento","estatus","error"],
            sortable: ["solicitado","usuario", "planta_referencia", "no_maquina", "edificio", "linea", "fecha_pago_real", "pedimento","estatus","error"],

            headings: {
                "planta_referencia":"Planta", 
                "no_maquina":"No. Maquina", 
                "edificio":"Edificio", 
                "linea":"Línea", 
                "fecha_pago_real":"Fecha Pedimento", 
                "pedimento":"No. Pedimento",
                actions: "Opciones"
            }
        },
                
        
        encabezadoLayoutImpo: {
            "Pedimento": "Pedimento",
            "Fecha Pago":"Fecha Pago",     
            "Factura":"Factura",
            "COVE":"COVE",
            "Fecha Factura":"Fecha Factura",
            "Proveedor":"Proveedor",
            "Material (# de Parte)":"Material (# de Parte)",
            "Cantidad":"Cantidad",
            "Unidad de medida":"Unidad de medida",
            "Kilos":"Kilos",
            "Valor $":"Valor $",
            "Moneda":"Moneda",
            "Secuencia":"Secuencia",
            "Comentarios":"Comentarios"
        },
        encabezadoLayoutExpo: {
            "Pedimento": "Pedimento",
            "Fecha Pago":"Fecha Pago",     
            "Factura":"Factura",
            "COVE":"COVE",
            "Fecha Factura":"Fecha Factura",
            "Cliente":"Cliente",
            "Material (# de Parte)":"Material (# de Parte)",
            "Cantidad":"Cantidad",
            "Unidad de medida":"Unidad de medida",
            "Kilos":"Kilos",
            "Valor $":"Valor $",
            "Moneda":"Moneda",
            "Secuencia":"Secuencia",
            "Comentarios":"Comentarios"
        },
        
        camposLayoutImpo: [{
            "Pedimento": "[No de Pedimento. Ej. 230730733011854]",
            "Fecha Pago":"[Fecha de Pago del Pedimento]",
            "Factura":"[Número de Factura]",
            "COVE":"[Número de COVE - OPCIONAL]",
            "Fecha Factura":"[Fecha de la Factura]",
            "Proveedor":"[Identificador del Proveedor]",
            "Material (# de Parte)":"[Material|# de Parte]",
            "Cantidad":"[Cantidad de Material]",
            "Unidad de medida":"[Unidad de medida Material]",
            "Kilos":"[Peso en Kilos del Material]",
            "Valor $":"[Valor en moneda]",
            "Moneda":"[Moneda MXN|MXP|USD]",
            "Secuencia":"[Número de Secuencia]",
            "Comentarios":"[Campo libre para Serie - OPCIONAL]"
        },{
            "Pedimento": "[La información debe comenzar a partir de esta fila (3ra fila)]",
            
        }],
        camposLayoutExpo: [{
            "Pedimento": "[No de Pedimento. Ej. 230730733011854]",
            "Fecha Pago":"[Fecha de Pago del Pedimento]",
            "Factura":"[Número de Factura]",
            "COVE":"[Número de COVE - OPCIONAL]",
            "Fecha Factura":"[Fecha de la Factura]",
            "Cliente":"[Identificador del Cliente]",
            "Material (# de Parte)":"[Material|# de Parte]",
            "Cantidad":"[Cantidad de Material]",
            "Unidad de medida":"[Unidad de medida Material]",
            "Kilos":"[Peso en Kilos del Material]",
            "Valor $":"[Valor en moneda]",
            "Moneda":"[Moneda MXN|MXP|USD]",
            "Secuencia":"[Número de Secuencia]",
            "Comentarios":"[Campo libre para Serie - OPCIONAL]"
        },{
            "Pedimento": "[La información debe comenzar a partir de esta fila (3ra fila)]",
            
        }],      
        LineaDescripcion: {
            "pedimento": "[No de Pedimento. Ej. 230730733011854]",
            "fecha_pago_real":"[Fecha de Pago del Pedimento]",     
            "factura":"[Número de Factura]",
            "cove":"[Número de COVE - OPCIONAL]",
            "fecha_factura":"[Fecha de la Factura]",
            "proveedor":"[Identificador del Proveedor/Cliente]",
            "material":"[Material|# de Parte]",
            "cantidad":"[Cantidad de Material]",
            "unidad_medida":"[Unidad de medida Material]",
            "kilos":"[Peso en Kilos del Material]",
            "valor_mercancia":"[Valor en moneda]",
            "moneda":"[Moneda MXN|MXP|USD]",
            "secuencia":"[Número de Secuencia]",
            "comentarios":"[Campo libre para Serie - OPCIONAL]"
        },        
        camposObligatorios: [
            "Pedimento",
            "Fecha Pago",
            "Factura",
            "Fecha Factura",            
            "Material (# de Parte)",
            "Cantidad",
            "Unidad de medida",
            "Kilos",
            "Valor $",
            "Moneda",
            "Secuencia"
        ],        
    }),
    methods: {
        verErrores: function(row){
            try {
                var arr_errores = row.errores.split("|");
                this.data_errores = [];
                arr_errores.forEach(e => {
                    this.data_errores.push({"error":e});
                });
                this.id_layout = row.id;
                this.rfc_layout = row.rfc;
                this.estatus_layout = row.estatus;
                
                this.modal_errores = true;
            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al mostrar la ventana de errores. Intente nuevamente.",
                    footer: ""
                });
                console.log(error);
            }            
        },

        validaFecha: function(fecha) {
            if (fecha == "Invalid date")
                return "Fecha no válida."
            else
                return true;
        },
        validaDias: function() {
            if (this.fecha_de != "" && this.fecha_a != "") {
                var inicio = moment(this.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia < 0)
                return "La Fecha Final no debe ser menor a la Fecha Inicial."
                if (Math.abs(diferencia) > 365)
                return "Periodo máximo de consulta un año. Favor de verificar."
            }
            return true;
        },        
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateMx(date) {
            //Formato  DD/MM/YYYY
            if (!date) return null;
            return moment(String(date)).format("DD/MM/YYYY");
        },
        
        beforeUpload(file) {
            var self = this;
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                if(self.fecha_de!=null && self.fecha_de!="" && self.fecha_a!=null && self.fecha_a!=""){
                    self.file_adjunto = file;                
                    return true;
                } else {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Seleccione primero el periodo de fechas",
                        footer: ""
                    });
                    return false;
                }
                
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            self.file_adjunto = null;
            return false;
        },
        validarPatronPedimento(pedimento){
            const patternPedimento = /^[0-9]{15}$/;
            return patternPedimento.test(pedimento);
        },        
        validaEntero(numero){
            const pattern = /^[\d]*$/;
            return pattern.test(numero);
        },
     
        
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }
            this.camposObligatorios.forEach(function (campo) {
                if (keys.indexOf(campo) == -1)
                    errores += '<br/>' + "- El campo '" + campo + "' es obligatorio.";
            });

            return errores == '' ? true : errores;
        },
        formatNumber: function (x) {
            if (x == undefined) return 0;
            x = x.toString();
            var pattern = /(-?\d+)(\d{3})/;
            while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
            return x;
        },

        parseDateExcel(excelDate) {
            try {
                if (!excelDate) return false;
                var fecha = '';
                if (excelDate.toString().indexOf('/') != -1 || excelDate.toString().indexOf('-') != -1){
                    fecha = moment(String(excelDate), ["DD/MM/YYYY", "DD-MM-YYYY", "YYYY-MM-DD", "MM/DD/YYYY"]).format("YYYY-MM-DD");
                }else{
                    fecha = moment((excelDate - (25567 + 1)) * 86400 * 1000).format("YYYY-MM-DD");
                }
                if (fecha == 'Invalid date') return false;
                return fecha;
            } catch (error) {
                return false;
            }
        },

        validaFloat: function(numero) {
            const pattern = /^\d*(\.\d*)?$/;
            return pattern.test(numero);
        },
                
        validaCargaLayoutImpo: async function (results) {
            var thisObject = this;
            //return new Promise(function(resolve, reject){
            var errores = 0;
            var erroresText = '';
            var errorTmp = '';
            try {
                if (results.length == 0) {
                    errores++;
                    erroresText += "No hay datos en el layout. Verifique que exista información a partir del 3er renglón.";
                //} else if (results.length > 2500){
                //    errores++;
                //    erroresText += "El máximo de filas a procesar es 2500, favor de verificar.";
                } else {
                    for (var k in results) {
                        results[k]['Pedimento'] = results[k]['Pedimento'].toString().replaceAll(' ', '');
                        var obligatorios = this.verificaObligatorios(results[k]);
                        if (obligatorios !== true) {
                            errores++;
                            if (erroresText.indexOf(obligatorios) == -1)
                                erroresText += obligatorios;
                        } else {
                            
                            if(!this.validarPatronPedimento(results[k]['Pedimento'])){
                                errores++;
                                errorTmp = '<br/>' + "- El pedimento '" + results[k]['Pedimento'] + "' no es un pedimento válido. Ej. 230730733011854";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if (thisObject.pestana_seleccionada=="importacion" && !results[k]["Proveedor"]){
                                errores++;
                                errorTmp = '<br/>' + "- El campo Proveedor es obligatorio";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else if (thisObject.pestana_seleccionada=="exportacion" && !results[k]["Cliente"]){
                                errores++;
                                errorTmp = '<br/>' + "- El campo Cliente es obligatorio";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            var fechaPago = results[k]["Fecha Pago"];
                            results[k]["Fecha Pago"] = this.parseDateExcel(results[k]["Fecha Pago"]);
                            if (results[k]["Fecha Pago"] == false) {
                                errores++;
                                errorTmp = '<br/>' + "- La fecha pago '" + fechaPago + "' no es una fecha válida.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            var fechaFactura = results[k]["Fecha Factura"];
                            results[k]["Fecha Factura"] = this.parseDateExcel(results[k]["Fecha Factura"]);
                            if (results[k]["Fecha Factura"] == false) {
                                errores++;
                                errorTmp = '<br/>' + "- La fecha factura '" + fechaFactura + "' no es una fecha válida.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if(!this.validaFloat(results[k]['Cantidad'])){                                
                                errores++;
                                errorTmp = '<br/>' + "- La Cantidad '" + results[k]['Cantidad'] + "' no es una cantidad válida.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else {
                                results[k]['Cantidad'] = parseFloat(results[k]['Cantidad']);
                            }

                            if(!this.validaFloat(results[k]['Kilos'])){                                
                                errores++;
                                errorTmp = '<br/>' + "- Los Kilos '" + results[k]['Kilos'] + "' no es una cantidad válida.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else {
                                results[k]['Kilos'] = parseFloat(results[k]['Kilos']);
                            }

                            if(!this.validaFloat(results[k]['Valor $'])){                                
                                errores++;
                                errorTmp = '<br/>' + "- El Valor $ '" + results[k]['Valor $'] + "' no es una cantidad válida.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else {
                                results[k]['Valor $'] = parseFloat(results[k]['Valor $']);
                            }

                            if(!this.validaEntero(results[k]['Secuencia'])){
                                errores++;
                                errorTmp = '<br/>' + "- la Secuencia '" + results[k]['Secuencia'] + "' debe ser un número entero válido.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else {
                                results[k]['Secuencia'] = parseInt(results[k]['Secuencia']);
                            }     

                            results[k]['Moneda'] = results[k]['Moneda'].toString().trim().toUpperCase();
                            if(!["MXN","MXP","USD"].includes(results[k]['Moneda'])){
                                errores++;
                                errorTmp = '<br/>' + "- La Moneda '"+results[k]['Moneda']+"' debe ser MXN|MXP|USD";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;    
                            } 
                                                       
                            //validaciones de longitud
                            if(results[k]['Factura'] && results[k]['Factura'].toString().length > 200){
                                errores++;
                                errorTmp = '<br/>' + "- La Factura '"+results[k]['Factura']+"' no debe tener más de 200 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;    
                            }
                            if(results[k]['COVE'] && results[k]['COVE'].toString().length > 200){
                                errores++;
                                errorTmp = '<br/>' + "- El COVE '"+results[k]['COVE']+"' no debe tener más de 200 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;    
                            }
                            if(results[k]['Proveedor'] && results[k]['Proveedor'].toString().length > 200){
                                errores++;
                                errorTmp = '<br/>' + "- El Proveedor '"+results[k]['Proveedor']+"' no debe tener más de 200 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;    
                            }
                            if(results[k]['Cliente'] && results[k]['Cliente'].toString().length > 200){
                                errores++;
                                errorTmp = '<br/>' + "- El Cliente '"+results[k]['Cliente']+"' no debe tener más de 200 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;    
                            }
                            if(results[k]['Material (# de Parte)'] && results[k]['Material (# de Parte)'].toString().length > 200){
                                errores++;
                                errorTmp = '<br/>' + "- El Material (# de Parte) '"+results[k]['Material (# de Parte)']+"' no debe tener más de 200 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;    
                            }
                            if(results[k]['Unidad de medida'] && results[k]['Unidad de medida'].toString().length > 200){
                                errores++;
                                errorTmp = '<br/>' + "- La Unidad de medida '"+results[k]['Unidad de medida']+"' no debe tener más de 200 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;    
                            }
                            if(results[k]['Comentarios'] && results[k]['Comentarios'].toString().length > 300){
                                errores++;
                                errorTmp = '<br/>' + "- El Comentario '"+results[k]['Comentarios']+"' no debe tener más de 300 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;    
                            }

                        }
                        
                    }

                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
            }
            //}); //promise

        },
        handleSuccessImpos: async function ({
            results,
            header
        }) {            
            var errores = 0;
            var erroresText = '';
            this.importData = [];
            
            try {                
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let validaciones = await this.validaCargaLayoutImpo(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                    this.$root.$dialogLoader.hide();
                } else {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

                    for (var k in results) {
                        this.importData.push({  
                            rfc: this.$local_storage.get("rfc"),                                                      
                            pedimento: results[k]['Pedimento'],
                            fecha_pago: results[k]['Fecha Pago'],
                            factura: results[k]['Factura'],
                            cove: results[k]['COVE']!=null ? results[k]['COVE'].toString().trim() : "",
                            fecha_factura: results[k]['Fecha Factura'],
                            proveedor: results[k]['Proveedor']?results[k]['Proveedor']:results[k]['Cliente'],
                            material: results[k]['Material (# de Parte)'],
                            cantidad: results[k]['Cantidad'],
                            unidad_medida: results[k]['Unidad de medida'],
                            kilos: results[k]['Kilos'],
                            valor_mercancia: results[k]['Valor $'],
                            moneda: results[k]['Moneda'],
                            secuencia: results[k]['Secuencia'], 
                            comentarios: results[k]['Comentarios']!=null ? results[k]['Comentarios'].toString().trim() : "",
                        });
                    }
                    var datos = {
                        rfc: this.$local_storage.get("rfc"),   
                        tipo: this.pestana_seleccionada, 
                        pedimentos: this.importData,
                        usuario_id: this.$local_storage.get("id_usuario"),
                        usuario: this.$local_storage.get("nombre_usuario"),
                        fecha_de: this.fecha_de,
                        fecha_a: this.fecha_a,
                        archivo: this.file_adjunto.name,
                        valida_pedimentos_layout: this.valida_pedimentos_layout
                    }

                    await axios.post("https://apireportes.econnectpro.mx/reportes_ds/save_layout_pedimentos/", datos)                    
                        .then((res) => {

                            this.$swal({
                                    type: "success",
                                    title: "Operación Exitosa",
                                    text: "El layout está En Proceso. Recibirá una notificación cuando termine.",
                                    footer: ""
                                }).then(()=>{
                                    this.cargar();
                                });

                        })
                        .catch(err => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al guardar los datos. Favor de intentar nuevamente.",
                                footer: ""
                            });                            
                            this.$root.$dialogLoader.hide();
                            this.cargar();
                        });
                    
                }

            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        }, 

        continuar_completar: function(id_layout, rfc, opcion=0){
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: rfc,
                id_layout: id_layout,
                opcion: opcion //Si opcion = 1, borra los errores para volver a validar, si es 0, es que lo mando el super usuario y solo quiere completarlo
            };

            axios({
                method: "post",
                url: "https://apireportes.econnectpro.mx/reportes_ds/completar_layout_pedimentos/",                
                data: data
            })
            .then(response => {                                
                this.$swal({
                    type: "success",
                    title: "Operación Exitosa",
                    text: "El layout está En Proceso. Recibirá una notificación cuando termine.",
                    footer: ""
                });
            })
            .catch(error => {
                let mensaje;
                var titulo = "¡Operación no Permitida!";
                var tipo = "error";
                if (typeof error.response !== "undefined") {
                    mensaje = error.response.data.mensaje;
                    if (error.response.status == 406){
                        titulo = "¡Ya existe un reporte en proceso!";
                        tipo = "info";
                    }
                } else {
                    mensaje = "Ocurrió un error al generar el layout. Puede revisar el error en el registro.";
                }
                this.$swal({
                    type: tipo,
                    title: titulo,
                    text: mensaje,
                    footer: ""
                });
            }).then(() => {   
                this.$root.$dialogLoader.hide();                             
                this.cargar();
                this.modal_errores = false;
            });
        },

        enviar_recuperar: function(id_layout, rfc){
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: rfc,
                id_layout: id_layout,
                id_usuario: this.$local_storage.get("id_usuario")
            };

            axios({
                method: "post",
                url: "https://apireportes.econnectpro.mx/reportes_ds/recuperar_layout_pedimentos/",                                
                data: data
            })
            .then(response => {                                
                this.$swal({
                    type: "success",
                    title: "Operación Exitosa",
                    text: "Se envió correctamente a recuperar partidas y pedimentos. Vuelva a verficar en un lapso de 24 hrs.",
                    footer: ""
                });
            })
            .catch(error => {
                let mensaje;
                var titulo = "¡Operación no Permitida!";
                var tipo = "error";
                if (typeof error.response !== "undefined") {
                    mensaje = error.response.data.mensaje;
                    if (error.response.status == 406){
                        titulo = "¡Ya existe un reporte en proceso!";
                        tipo = "info";
                    }
                } else {
                    mensaje = "Ocurrió un error al enviar a recuperar. Intente nuevamente por favor.";
                }
                this.$swal({
                    type: tipo,
                    title: titulo,
                    text: mensaje,
                    footer: ""
                });
            }).then(() => {   
                this.$root.$dialogLoader.hide();                             
                this.cargar();
                this.modal_errores = false;
            });
        },

        
        cargar: function() {
            var self = this;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.$local_storage.get('rfc')                
            };
            axios.post("https://apireportes.econnectpro.mx/reportes_ds/get_layout_pedimentos/", data)            
            .then(async res => {
                if (typeof res.data !== "undefined") {
                    var data = res.data;
                    data.sort(function(a, b) {
                        //Ordenar por fecha más reciente
                        return new Date(b.fecha) - new Date(a.fecha) ;
                    });
                    for (var k in data) {
                        data[k].fecha = this.parseDate(data[k].fecha);
                        data[k].estatus = this.getEstatus(data[k].estatus);
                        if(data[k].fecha_de && data[k].fecha_a)
                            data[k].periodo = this.parseDate(data[k].fecha_de) + " a " + this.parseDate(data[k].fecha_a);
                        else 
                            data[k].periodo = "Sin periodo";
                    }

                    await Promise.all(data.map(async (x) => {

                        let data = {
                            id_layout: x.id,
                            rfc: x.rfc
                        };

                        if(x.estatus == "En Proceso"){                            

                            await axios
                                .post("https://apireportes.econnectpro.mx/reportes_ds/get_count_faltante/", data)                                
                                .then((res) => {
                                    x.faltantes = self.formatNumber(res.data,0);
                                })
                                .catch((err) => {
                                
                                });
                        } else if (x.estatus == "Pendiente"){
                            axios({
                                method: "post",
                                url: "https://apireportes.econnectpro.mx/reportes_ds/completar_layout_pedimentos/",                                
                                data: data
                            })
                            .then(response => {                                
                                
                            })
                            .catch(error => {
                                console.log("Error al completar_layout_pedimentos2: ", error);
                            })
                        }
                    }));
                    

                    this.datos = data.filter(e => e.tipo_layout == "importacion");
                    this.datos_expo = data.filter(e => e.tipo_layout == "exportacion");

                    
                }
            })
            .catch(err => {
                console.log(err);
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener los registros. Favor de intentar nuevamente.",
                    footer: "",
                });
            }).then(() => {
                this.$root.$dialogLoader.hide();
            });
        },
        getEstatus: function(estatus) {
            var arr_estatus = ["Pendiente", "En Proceso", "Generado Correctamente", "Con Errores", "Enviados a Recuperación"];
            if (estatus in arr_estatus)
                return arr_estatus[estatus];
            else
                return "N/A";
        },
        getTablaPedimentos: function(id, nombre_archivo, periodo, tipo_operacion=1,tipo="completo"){
           this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            
           this.data_completo = [];
            var rfc = this.$local_storage.get('rfc');
            let data = {
                rfc: rfc,
                id: id
            };

            axios.post("https://apireportes.econnectpro.mx/reportes_ds/get_detalle_layout_pedimentos/", data)                           
            .then(res => {
                if (typeof res.data !== "undefined") {
                    this.data_completo = res.data;  
                    for (var k in this.data_completo) {
                        this.data_completo[k].fecha_pago_real = this.parseDateMx(this.data_completo[k].fecha_pago_real);
                        this.data_completo[k].fecha_entrada = this.parseDateMx(this.data_completo[k].fecha_entrada);
                        this.data_completo[k].fecha_factura = this.parseDateMx(this.data_completo[k].fecha_factura);
                        this.data_completo[k]["adicional5"] = "1"; //default
                        //(2025-01-09): Solicitaron que solo se muestren los kilos en la columna Peso Neto para estas 2 empresas
                        if(["PCI890511DY0","MMI910827JY5"].includes(rfc)){                            
                            this.encabezadoCompleto["Peso Neto"] = "kilos";
                            this.encabezadoCompletoExpo["Peso Neto"] = "kilos";
                        }
                        //(2025-03-04): Solicitaron que para el RFC:RPA040310JS2 el encabezado completo muestre el pedimento pegado, no el separado como en los demas
                        if(["RPA040310JS2"].includes(rfc)){                            
                            this.encabezadoCompleto["Pedimento"] = "pedimento";
                            this.encabezadoCompletoExpo["Pedimento"] = "pedimento";
                        }
                    }
                                                                    
                }
            })
            .catch(err => {
                console.log(err);
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al obtener los pedimentos. Favor de intentar nuevamente.",
                    footer: "",
                });
            }).then(() => {
                this.$root.$dialogLoader.hide();
                 if(tipo=="completo"){     
                    if(tipo_operacion == 1)                   
                        var btn = document.getElementById('botonExportarCompleto');
                    else
                        var btn = document.getElementById('botonExportarCompletoExpo');
                    
                    this.nombre_archivo = nombre_archivo?"ArmadoA24_"+nombre_archivo:"ArmadoA24 "+periodo+".xlsx";                                   
                } else {
                    if(tipo_operacion == 1){      
                        var btn = document.getElementById('botonExportarLayout');                        
                    } else{
                        var btn = document.getElementById('botonExportarLayoutExpo');                        
                    }
                    this.data_completo.unshift(this.LineaDescripcion);
                    this.nombre_archivo = nombre_archivo?nombre_archivo:"LayoutOriginal "+periodo+".xlsx";
                } 
                this.$nextTick(() => {
                    if(btn){
                        btn.click();                        
                    }
                });
            });
        },
        getValidacion: function(id, nombre_archivo, periodo){
           this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

           this.validacion = [];
           
            let data = {
                rfc: this.$local_storage.get('rfc'),
                id: id
            };

            axios.post("https://apireportes.econnectpro.mx/reportes_ds/get_confronta_armado24/", data)            
            .then(res => {
                if (typeof res.data !== "undefined") {
                    this.validacion = res.data;  
                                                                    
                }
            })
            .catch(err => {
                console.log(err);
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al obtener los pedimentos. Favor de intentar nuevamente.",
                    footer: "",
                });
            }).then(() => {
                this.$root.$dialogLoader.hide();                                     
                var btn = document.getElementById('botonExportarValidacion'); 
                this.nombre_archivo = nombre_archivo?"Validaciones_"+nombre_archivo:"Validaciones "+periodo+".xlsx";
                this.$nextTick(() => {
                    if(btn){
                        btn.click();                        
                    }
                });              
            });
        },
        eliminarReporte: function (idreporte) {
            this.$swal({
              type: "info",
              title: "Cuidado",
              text: "¿Está seguro de eliminar el registro con No. Proceso: "+idreporte+"?",
              footer: "",
              showCancelButton: true,
              cancelButtonColor: "#d33",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar"
          }).then(result => {
              if (result.value) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var datos = {
                    id_layout: idreporte,
                }
                axios.post('https://apireportes.econnectpro.mx/reportes_ds/delete_layout_pedimentos/', datos)                
                    .then((res) => {
                    this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El registro se eliminó correctamente",
                            footer: ""
                        });
                    })
                    .catch((error) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el registro. Favor de comunicarse con soporte.",
                            footer: '',
                        });
                        console.log(error);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.cargar();                        
                    });
              }
          });
        },
        downloadReporte: function(key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                if (typeof res.data !== 'undefined') {
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = res.data.mensaje;
                    a.target = '_blank';
                    a.click();
                    a.parentNode.removeChild(a);

                } else {
                    this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                    footer: '',
                    });
                }
                })
                .catch((error) => {
                var mensaje = "Ocurrió un error al descargar el archivo";
                if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                    mensaje = error.response.data.mensaje;
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: mensaje,
                    footer: '',
                });
                console.log(error);
                }).then(() => {
                this.$root.$dialogLoader.hide();
                });
            },
            descargar_prellenado: async function(opcion){
                if (!this.$refs.form_dates.validate()) {
                    return
                }
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var datos = {
                    fecha_de: this.fecha_de,
                    fecha_a: this.fecha_a,
                    rfc: this.$local_storage.get('rfc'),
                    tipo_operacion: opcion,
                }
                await axios.post(this.$apiSA31 + "soluciona24/layout_prellenado_sa24/", datos)
                    .then(async (res) => {
                        if (typeof res.data !== 'undefined') {
                            await this.generate_excel(res.data, opcion)
                        } else {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: 'Ocurrió un error al descargar el archivo. Favor de comunicarse con soporte.',
                                footer: '',
                            });
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        var mensaje = "Ocurrió un error al descargar el archivo";
                        if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                            mensaje = error.response.data.mensaje;
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: mensaje,
                            footer: '',
                        });
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                    });
            },
            generate_excel: async function(data, tipo){
                if (tipo == 1){
                    var items = [{
                        'Pedimento': '[No de Pedimento. Ej. 2507030733011854]',
                        'Fecha Pago': '[Fecha Pago Real del Pedimento]',
                        'Factura': '[Número de Factura]',
                        'COVE': '[Número de COVE - OPCIONAL]',
                        'Fecha Factura': '[Fecha de la Factura]',
                        'Proveedor': '[Identificador del Proveedor]',
                        'Material (# de Parte)': '[Material | # de Parte]',
                        'Cantidad': '[Cantidad de Material]',
                        'Unidad de medida': '[Unidad de medida Material]',
                        'Kilos': '[Peso en Kilos del Material]',
                        'Valor $': '[Valor en moneda]',
                        "Moneda": '[Moneda MXN|MXP|USD]',
                        'Secuencia': '[Número de Secuencia]',
                        "Comentarios": '[Campo libre para Serie]',
                    }];
                } else {
                    var items = [{
                        'Pedimento': '[No de Pedimento. Ej. 2507030733011854]',
                        'Fecha Pago': '[Fecha Pago Real del Pedimento]',
                        'Factura': '[Número de Factura]',
                        'COVE': '[Número de COVE - OPCIONAL]',
                        'Fecha Factura': '[Fecha de la Factura]',
                        'Cliente': '[Identificador del Cliente]',
                        'Material (# de Parte)': '[Material | # de Parte]',
                        'Cantidad': '[Cantidad de Material]',
                        'Unidad de medida': '[Unidad de medida Material]',
                        'Kilos': '[Peso en Kilos del Material]',
                        'Valor $': '[Valor en moneda]',
                        "Moneda": '[Moneda MXN|MXP|USD]',
                        'Secuencia': '[Número de Secuencia]',
                        "Comentarios": '[Campo libre para Serie]',
                    }]
                }

                if (this.$local_storage.get("rfc") == "NMP140226GW3"){
                    items[0]['Clave Pedimento'] = '[Clave del Pedimento]';
                }

                const tipo_operacion = tipo == 1 ? 'Importaciones' : 'Exportaciones';
                var name = "Layout_Pre-llenado_" + tipo_operacion + "_" + this.fecha_de + "_"+ this.fecha_a + ".xlsx";
        
                data.forEach((item) => {
                    
                    if (tipo == 1){
                        var new_item = {
                            'Pedimento':  item['no_pedimento'] ,
                            'Fecha Pago' : item['fecha_pago'],
                            'Factura':  item['factura'],
                            'COVE':  item['cove'],
                            'Fecha Factura':   item['fecha_factura'],
                            'Proveedor':   item['proveedor'],
                            'Material (# de Parte)':  item['material'],
                            'Cantidad':  item['cantidad'] ,
                            'Unidad de medida':   item['unidad_medida'],
                            'Kilos':   item['kilos'],
                            'Valor $': item['valor'],
                            "Moneda": item['moneda'],
                            'Secuencia':   item['secuencia'],
                            "Comentarios": item['observaciones'],
                        };
                    } else {
                        var new_item = {
                            'Pedimento':  item['no_pedimento'] ,
                            'Fecha Pago' : item['fecha_pago'],
                            'Factura':  item['factura'],
                            'COVE':  item['cove'],
                            'Fecha Factura':   item['fecha_factura'],
                            'Cliente':   item['proveedor'],
                            'Material (# de Parte)':  item['material'],
                            'Cantidad':  item['cantidad'] ,
                            'Unidad de medida':   item['unidad_medida'],
                            'Kilos':   item['kilos'],
                            'Valor $': item['valor'],
                            "Moneda": item['moneda'],
                            'Secuencia':   item['secuencia'],
                            "Comentarios": item['observaciones'],
                        };
                    }
                    if (this.$local_storage.get("rfc") == "NMP140226GW3"){
                        new_item['Clave Pedimento'] = item['clave_pedimento'];
                    }
                    items.push(new_item);
                
                });
        
                const worksheet = XLSX.utils.json_to_sheet(items);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Pre-llenado " + tipo_operacion);
                XLSX.writeFile(workbook, name, { compression: true });
            },
            puede_generar_layout: function(){
                return ["NMP140226GW3"].includes(this.$local_storage.get("rfc"));
            },

                  
        
    }, //methods

    created: function () {    
        this.URL = this.$hostname+"reportes/"; 
        var tipoUsuario = this.$local_storage.get("tipo_usuario");
        if (tipoUsuario == "Super Usuario") {
            this.superUsuario = true;
        }
        
        this.cargar();                

    }
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: x-small !important;
}
.elevation-1 .v-expansion-panel >>> .v-label.theme--light {
        color: black !important;
    }    

#html_codigo_qr {
  display: inline-block;
  height: auto;
}
#html_codigo_qr img {
  max-width: 100%;
}

</style>
